var React = require('react');

function ArrowBlack (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Right Arrow"),React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"transform":"translate(-541.000000, -4039.000000)","stroke":"#1A1C2C","strokeWidth":"2"},React.createElement("g",{"transform":"translate(541.000000, 4040.000000)"},[React.createElement("line",{"x1":"0","y1":"15","x2":"43","y2":"15","transform":"translate(21.500000, 15.000000) rotate(-360.000000) translate(-21.500000, -15.000000) ","key":0}),React.createElement("polyline",{"transform":"translate(35.000000, 15.000000) rotate(-360.000000) translate(-35.000000, -15.000000) ","points":"27 30 43 15.0001293 27 0","key":1})])))]);
}

ArrowBlack.defaultProps = {"width":"45px","height":"32px","viewBox":"0 0 45 32","version":"1.1"};

module.exports = ArrowBlack;

ArrowBlack.default = ArrowBlack;
